/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';

import type { RawDownloadResponseDto } from '../models/RawDownloadResponseDto';

import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

@Injectable()
export class RawDataService {

    constructor(public readonly http: HttpClient) {}

    /**
     * @param formId 
     * @param showQuestionTitle 
     * @returns RawDownloadResponseDto Success
     * @throws ApiError
     */
    public download(
formId: string,
showQuestionTitle: boolean = false,
): Observable<RawDownloadResponseDto> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/rawdataexport/download/{formId}/{showQuestionTitle}',
            path: {
                'formId': formId,
                'showQuestionTitle': showQuestionTitle,
            },
        });
    }

}
